import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { selectBudgetCategory } from '../actions/index.js';

const budgetCategory = [
  { name: 'social', title: '福利服務支出' },
  { name: 'medical', title: '醫療健保支出' },
  { name: 'education', title: '教育支出' },
  { name: 'transportation', title: '交通支出' },
  { name: 'finance', title: '其他經濟支出' },
  { name: 'community', title: '社區發展支出' },
  { name: 'environment', title: '環境保護支出' },
  { name: 'police', title: '警政支出' },
];

class BudgetCategory extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectBudgetCategory = this.handleSelectBudgetCategory.bind(this);
  }
  handleSelectBudgetCategory(category) {
    this.props.selectBudgetCategory(category.name, category.title);
  }
  render() {
    return (
      <div className="budget-category">
        {budgetCategory.map((category, index) =>
          <div
            className={`budget-button
            ${category.name === this.props.budgetCategory ? 'active' : ''}`}
            key={category.name}
            tabIndex={index}
            onClick={() => this.handleSelectBudgetCategory(category)}
          >
            <i className={`icon icon-${category.name}`}></i>
            <div className="title">{category.title}</div>
            <i className="fa fa-chevron-down more" aria-hidden="true" />
          </div>
        )}
      </div>
    );
  }
}

BudgetCategory.propTypes = {
  selectBudgetCategory: PropTypes.func,
  budgetCategory: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    budgetCategory: state.budget.category,
  };
}

export default connect(mapStateToProps, { selectBudgetCategory })(BudgetCategory);



/** WEBPACK FOOTER **
 ** ./src/components/budget-category.js
 **/